import "./sidebar.scss";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ScienceIcon from "@mui/icons-material/Science";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import BiotechIcon from "@mui/icons-material/Biotech";
import ShareLocationIcon from "@mui/icons-material/BookmarksRounded";
import RequestIcon from "@mui/icons-material/DateRange";
import NewRequestIcon from "@mui/icons-material/PendingActions";
import SymptomsIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import DoctorIcon from "@mui/icons-material/MedicalServices";

import { Link } from "react-router-dom";
import { DarkModeContext } from "../../context/darkModeContext";
import { useContext } from "react";

const Sidebar = () => {
  const { dispatch } = useContext(DarkModeContext);
  return (
    <div className="sidebar">
      <div className="top">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span className="logo">HELLO DOCTOR</span>
        </Link>
      </div>
      <hr />
      <div className="center">
        <ul>
          <p className="title">MAIN</p>
          <Link to="/users" style={{ textDecoration: "none" }}>
            <li>
              <PersonOutlineIcon className="icon" />
              <span>Users</span>
            </li>
          </Link>
          <p className="title">ADMIN</p>
         
          <Link to="/request" style={{ textDecoration: "none" }}>
            <li>
              <NewRequestIcon className="icon" />
              <span>Doctor Request</span>
            </li>
          </Link>
          <Link to="/lab-request" style={{ textDecoration: "none" }}>
            <li>
              <RequestIcon className="icon" />
              <span>Lab Requests</span>
            </li>
          </Link>
          <p className="title">doctors</p>

          <Link to="/clinics" style={{ textDecoration: "none" }}>
            <li>
              <ScienceIcon className="icon" />
              <span>Clinics</span>
            </li>
          </Link>
          <Link to="/doctors" style={{ textDecoration: "none" }}>
            <li>
              <DoctorIcon className="icon" />
              <span>Doctors</span>
            </li>
          </Link>

          <Link to="/lab" style={{ textDecoration: "none" }}>
            <li>
              <BiotechIcon className="icon" />
              <span>Lab</span>
            </li>
          </Link>

          {/* <Link to="/chat" style={{ textDecoration: "none" }}>
            <li>
              <ChatIcon className="icon" />
              <span>Chat</span>
            </li>
          </Link> */}
          <p className="title">SERVICE</p>

          <Link to="/banner" style={{ textDecoration: "none" }}>
            <li>
              <InsertChartIcon className="icon" />
              <span>Add Banner</span>
            </li>
          </Link>
          <Link to="/notification" style={{ textDecoration: "none" }}>
            <li>
              <NotificationsNoneIcon className="icon" />
              <span>Notifications</span>
            </li>
          </Link>
          <Link to="/category" style={{ textDecoration: "none" }}>
            <li>
              <ScienceIcon className="icon" />
              <span>Category</span>
            </li>
          </Link>
  
          
          {/* <Link to="" style={{ textDecoration: "none" }}>
            <li>
              <SettingsApplicationsIcon className="icon" />
              <span>Settings</span>
            </li>
          </Link> */}
          <p className="title">LIST</p>

          <Link to="/specialities" style={{ textDecoration: "none" }}>
            <li>
              <AddBusinessIcon className="icon" />
              <span>Specialities</span>
            </li>
          </Link>

          <Link to="/symptoms" style={{ textDecoration: "none" }}>
            <li>
              <SymptomsIcon className="icon" />
              <span>Symptoms</span>
            </li>
          </Link>
          <Link to="/servicies" style={{ textDecoration: "none" }}>
            <li>
              <ShareLocationIcon className="icon" />
              <span>Servicies</span>
            </li>
          </Link>
        </ul>
      </div>
      <div className="bottom">
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "LIGHT" })}
        ></div>
        <div
          className="colorOption"
          onClick={() => dispatch({ type: "DARK" })}
        ></div>
      </div>
    </div>
  );
};

export default Sidebar;
